import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/index';

export default function getRootModule() {
  return {
    id: 'REGISTER_BUSSINES_RULES',
    reducerMap: {
      REGISTER_BUSSINES_RULES: rootReducer,
    },
    sagas: [rootSagas],
  };
}
